<template lang="pug">
.ui.segment(style='padding: 20px 30px')
  p 
    span 电表编号: {{room.lezhu_meter_id}}
    span(style='margin: 0 20px')
    span 上次更新: {{$formatters.date.from_now(info.time_updated)}}
    span(style='margin: 0 20px')

    span.ui.button.small.compact.themed(@click='query()') 立即更新
    

  table.ui.very.basic.celled.table(v-if='room.lezhu_info')
    thead
      th 表名
      th 余额
      th 电价
      th 已使用
      th 设备状态
      th 网络状态
      th 自动断电

    tbody
      td {{info.name}}
      th(:class='info.balance.startsWith("-") ? "error": ""') {{info.balance}}
      td {{info.price}} 元/度
      td {{info.curUsed}}度
      td(:class='stateClass(deviceState(info.deviceState))') {{deviceState(info.deviceState)}}
      td(:class='stateClass(info.netState)') {{info.netState}}
      td {{autobreak(info.autobreak)}}

  el-collapse(v-if='info.bills')
    el-collapse-item(title='乐住缴费记录')
      table.ui.very.basic.table(style='margin: 0 20px')
        thead
          th ID
          th 缴费日期
          th.right.aligned 金额
          th 状态
          th 类型

        tbody
          tr(v-for='item in info.bills')
            td {{item.id}}
            td {{item.time}}
            td.right.aligned {{item.money}} 元
            td {{item.state}}
            td {{item.typeName}}

</template>


<script>
import { MakeForm } from '../../utils'

export default {
  props: {
    room: Object,
  },
  computed: {
    info() {
      return this.room.lezhu_info || {}
    },
  },
  methods: {
    query: MakeForm({
      type: 'put',
      url: 'charges/lezhu/query',
      confirm: undefined,
      payload() {
        return {
          _room: this.room._id,
          meter_id: this.room.lezhu_meter_id,
        }
      },
      $afterSuccess(body) {
        this.room.lezhu_info = Object.assign(this.room.lezhu_info || {}, body)
      },
    }),
    deviceState(state) {
      return {
        0: '正常',
      }[state] || '已断电'
    },
    stateClass(state) {
      return {
        正常: '-',
      }[state] || 'error'
    },
    autobreak(data = {}) {
      if (!data.state)
        return '未设置'
      return `低于${data.num}度时自动断电`
    },
  },
}
</script>



// WEBPACK FOOTER //
// LezhuMonitor.vue?b187f40e